
import "../../Tooltip/Tooltip.st.css.js";
import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_146_2_Ellipsis";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_146_2_Ellipsis__root","tooltip":"wds_1_146_2_Ellipsis__tooltip"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"maxLines":"--wds_1_146_2_Ellipsis-maxLines"}; 




